import React from 'react';

import { EUserStoreRole } from '@domain/enums/common/userStore/EUserStoreRole';

import { useStoreConfig } from '@helpers/hooks/useStoreConfig';
import { useConfig } from '@helpers/hooks/useConfig';

import { OrdersProvider } from '@helpers/hooks/pages/dashboard/orders/useOrders';

import NoAccess from '@components/common/core/Utils/NoAccess';
import Wrapper from '@components/Dashboard/Orders/Wrapper';

const Orders: React.FC = () => {
  const { accessManagementData } = useStoreConfig();
  const { isInternalTeam } = useConfig();

  const isStoreOwner = accessManagementData?.role === EUserStoreRole.OWNER;
  const hasAccessToPage =
    accessManagementData?.group?.has_orders_table_full_write_access ||
    accessManagementData?.group?.has_orders_table_full_read_access;

  if (!isStoreOwner && !hasAccessToPage && !isInternalTeam) {
    return <NoAccess />;
  }

  return (
    <OrdersProvider>
      <Wrapper />
    </OrdersProvider>
  );
};

export default Orders;
